import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";

import { tr } from "../lib/i18n";
export default function ChangePasswordPage() {
  const { user, changePassword, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 10) return toast.error(tr("x.password_must_be_at_least_10_characters"));
    if (next !== confirm) return toast.error(tr("x.passwords_do_not_match"));
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success(tr("x.password_updated"));
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form
        data-testid="change-password-form"
        onSubmit={submit}
        className="panel w-full max-w-md p-8 space-y-5"
      >
        <div>
          <div className="eyebrow mb-2">{tr("x.security")}</div>
          <h2 className="text-2xl font-semibold" style={{ fontFamily: "Outfit" }}>
            {user?.must_change_password ? tr("x.set_a_new_password") : tr("x.change_password")}
          </h2>
          {user?.must_change_password && (
            <p className="text-sm text-[var(--gray-400)] mt-1">
              {tr("x.first_time_sign_in_please_choose_a_new_p")}
            </p>
          )}
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-[var(--gray-400)]">{tr("x.current_password")}</label>
            <input
              data-testid="current-password"
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className="mt-2 w-full h-11 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--card))] px-4 text-sm outline-none focus:border-[var(--accent)]"
              required
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-[var(--gray-400)]">{tr("x.new_password")}</label>
            <input
              data-testid="new-password"
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className="mt-2 w-full h-11 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--card))] px-4 text-sm outline-none focus:border-[var(--accent)]"
              required
              minLength={10}
              aria-describedby="pw-help"
            />
            <p id="pw-help" data-testid="password-help" className="mt-1.5 text-xs text-[var(--gray-400)]">
              {tr("x.at_least_10_characters_avoid_common_pass")}
            </p>
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-[var(--gray-400)]">{tr("x.confirm_new_password")}</label>
            <input
              data-testid="confirm-password"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-2 w-full h-11 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--card))] px-4 text-sm outline-none focus:border-[var(--accent)]"
              required
              minLength={10}
            />
          </div>
        </div>

        <div className="flex gap-2">
          <button
            data-testid="submit-change-password"
            type="submit"
            disabled={busy}
            className="flex-1 h-11 rounded-lg bg-accent-brand text-white font-semibold text-sm disabled:opacity-60"
          >
            {busy ? tr("x.updating") : tr("x.update_password")}
          </button>
          {!user?.must_change_password && (
            <button
              type="button"
              onClick={() => nav(-1)}
              className="h-11 px-4 rounded-lg border border-[hsl(var(--border))] text-sm hover:bg-[hsl(var(--muted))]"
            >
              {tr("x.cancel")}
            </button>
          )}
        </div>

        {user?.must_change_password && (
          <button
            type="button"
            className="text-xs text-[var(--gray-400)] hover:text-accent-brand underline"
            onClick={async () => {
              await logout();
              nav("/login");
            }}
          >
            {tr("x.sign_out_instead")}
          </button>
        )}
      </form>
    </div>
  );
}
